import { DirectoryCreateOrUpdateModal } from '@/features/drive/functionalities/actions/node/core/shared/directory-create-or-update-modal/directory-create-or-update-modal'
import { NodeRenameActionModal } from '@/features/drive/functionalities/actions/node/core/node-rename-action/node-rename-action-modal'
import {
    INodeAction,
    IUseActionReturnType,
    NodeActionScope,
} from '@/features/drive/functionalities/actions/node/core/shared/utils/node-action-helpers'
import { useNodeItemContext } from '@/features/drive/entities/node/node-item-context'
import { Edit } from 'lucide-react'
import { Fragment, useMemo, useState } from 'react'
import { NodeType } from '@/api/nodes/mutations/directory/create-directory-mutation'

export const useNodeRenameAction = (): IUseActionReturnType => {
    const [openRenameModal, setOpenRenameModal] = useState(false)

    const { node } = useNodeItemContext()

    const action: INodeAction = useMemo(() => {
        return {
            icon: Edit,
            label: 'Rename',
            call: () => setOpenRenameModal(true),
            availableForScopes: [NodeActionScope.SELECTED_SINGLE, NodeActionScope.PREVIEW],
            applicableForTypes: [NodeType.FILE, NodeType.DIRECTORY],
        }
    }, [setOpenRenameModal])

    const nodes = useMemo(() => {
        return (
            <Fragment>
                {openRenameModal && node.type === NodeType.FILE && (
                    <NodeRenameActionModal
                        isOpen={openRenameModal}
                        node={node}
                        onClose={() => setOpenRenameModal(false)}
                    />
                )}

                {openRenameModal && node.type === NodeType.DIRECTORY && (
                    <DirectoryCreateOrUpdateModal
                        open={openRenameModal}
                        directory={node}
                        onOpenChange={setOpenRenameModal}
                    />
                )}
            </Fragment>
        )
    }, [node, openRenameModal])

    return { action, nodes }
}
